module.exports = __webpack_public_path__ + "static/img/ANTICA-MAPLE.9518ec5.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/ANTICA-MAPLE.png
// module id = G/2q
// module chunks = 0